module.exports = __webpack_public_path__ + "static/feature1-a4653161650925f908230cb2af427d2b.png";